<template>
    <div class="main-content">
        <div class="uk-padding">
            <ul class="uk-breadcrumb">
                <li><router-link to="/pages">Pagina's</router-link></li>
            </ul>
            <h1 class="uk-align-left">Pagina's</h1>
            <div class="uk-align-right">
                <a href="#page-modal" uk-toggle uk-icon="icon: plus; ratio: 2"></a>
            </div>
            <table class="uk-table">
                <thead>
                    <tr>
                        <th width="30"></th>
                        <th>Naam</th>
                        <th>Laatste update</th>
                        <th width="60"></th>
                    </tr>
                </thead>
                <tbody>
                    <tr v-for="(p, id) in pages">
                        <td><span uk-icon="icon: copy; ratio: 1.2"></span></td>
                        <td>{{p.name}}</td>
                        <td>{{convertDate(p.lastEdit)}}</td>
                        <td>
                            <router-link :to="{ name: 'PageEdit', params: { id: id }}" class="uk-link" uk-icon="icon: cog"></router-link>
                        </td>
                    </tr>
                </tbody>
            </table>
        </div>
        <div id="page-modal" uk-modal>
            <div class="uk-modal-dialog">
                <button class="uk-modal-close-default" type="button" uk-close></button>
                <div class="uk-modal-header">
                    <h2 class="uk-modal-title">Pagina maken</h2>
                </div>
                <div class="uk-modal-body">
                    <form>
                        <fieldset class="uk-fieldset">
                             <div class="uk-margin">
                                <input class="uk-input" v-model="newPage.name" type="text" placeholder="Naam">
                            </div>
                        </fieldset>
                    </form>
                </div>
                <div class="uk-modal-footer">
                    <div class="uk-align-right">
                        <button class="uk-button uk-button-primary uk-align-right uk-modal-close" type="submit" @click.prevent="add">Uitnodigen</button>
                        <button class="uk-button uk-button-danger uk-align-right uk-modal-close" @click="cancel">Annuleren</button>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>
<script>
var moment = require('moment');
import {db} from '@/CUSTOM/helpers/firebase'
export default {
    name: 'Pages',
    data () {
        return {
            pages: null,
            newPage: {
                name: null
            }
        }
    },
    created () {
        db.collection('pages').onSnapshot((snap) => {
            this.pages = {}
            snap.forEach((doc) => {
                this.pages[doc.id] = doc.data()
            })
        })
    },
    methods: {
        add () {
            this.newPage.created = Math.floor(Date.now() / 1000)
            this.newPage.lastEdit = Math.floor(Date.now() / 1000)
            //TODO: CHECK IF PAGE NAME ALREADY EXSISTS
            db.collection('pages').doc(this.newPage.name).set(this.newPage)
        },
        cancel () {
            this.newPage = {
                name: null
            }
        },
        convertDate (timestamp) {
            return moment.unix(timestamp).fromNow();
        }
    }
}
</script>


// WEBPACK FOOTER //
// Pages.vue?52c8eb1a